import React from 'react';

const Tsogchen = () => {
    return (
        <h1>Цогчэн</h1>
    )
}
export default Tsogchen;